// Centralized data-testid registry
export const NAV = {
  logo: "nav-logo",
  recipes: "nav-recipes",
  shop: "nav-shop",
  submit: "nav-submit",
  profile: "nav-profile",
  cart: "nav-cart",
  langToggle: "nav-lang-toggle",
  login: "nav-login",
  logout: "nav-logout",
  mobileMenu: "nav-mobile-menu",
};

export const HOME = {
  heroCta: "home-hero-cta",
  shopCta: "home-shop-cta",
  recipeCard: (slug) => `home-recipe-card-${slug}`,
  countryChip: (c) => `home-country-${c}`,
  emergentLink: "home-emergent-link",
};

export const RECIPES = {
  search: "recipes-search",
  countrySelect: "recipes-country-select",
  typeSelect: "recipes-type-select",
  difficultySelect: "recipes-difficulty-select",
  clearFilters: "recipes-clear-filters",
  card: (slug) => `recipes-card-${slug}`,
  empty: "recipes-empty",
};

export const RECIPE = {
  title: "recipe-title",
  back: "recipe-back",
  ingredientsTab: "recipe-tab-ingredients",
  stepsTab: "recipe-tab-steps",
};

export const SHOP = {
  productCard: (slug) => `shop-product-card-${slug}`,
  addToCart: (slug) => `shop-add-to-cart-${slug}`,
  category: (c) => `shop-category-${c}`,
  cardLink: (slug) => `shop-card-link-${slug}`,
  detailTitle: "product-detail-title",
  detailAddToCart: "product-detail-add-to-cart",
  detailBack: "product-detail-back",
  detailNotFound: "product-detail-not-found",
  similarCard: (slug) => `product-similar-${slug}`,
};

export const CART = {
  drawerOpen: "cart-drawer-open",
  itemQty: (id) => `cart-qty-${id}`,
  removeItem: (id) => `cart-remove-${id}`,
  checkoutBtn: "cart-checkout",
  empty: "cart-empty",
  total: "cart-total",
};

export const CHECKOUT = {
  nameInput: "checkout-name",
  addressInput: "checkout-address",
  cityInput: "checkout-city",
  countryInput: "checkout-country",
  emailInput: "checkout-email",
  submit: "checkout-submit",
  successOrderId: "checkout-success-order-id",
};

export const AUTH = {
  emailInput: "auth-email",
  passwordInput: "auth-password",
  nameInput: "auth-name",
  submit: "auth-submit",
  googleBtn: "auth-google-btn",
  toggle: "auth-toggle",
  error: "auth-error",
  forgotLink: "auth-forgot-link",
  forgotEmail: "forgot-email",
  forgotSubmit: "forgot-submit",
  forgotSuccess: "forgot-success",
  resetPassword: "reset-password",
  resetConfirm: "reset-confirm",
  resetSubmit: "reset-submit",
  resetError: "reset-error",
};

export const SUBMIT = {
  titleFr: "submit-title-fr",
  titleEn: "submit-title-en",
  country: "submit-country",
  type: "submit-type",
  difficulty: "submit-difficulty",
  time: "submit-time",
  image: "submit-image",
  summaryFr: "submit-summary-fr",
  summaryEn: "submit-summary-en",
  ingredientsFr: "submit-ingredients-fr",
  ingredientsEn: "submit-ingredients-en",
  stepsFr: "submit-steps-fr",
  stepsEn: "submit-steps-en",
  submit: "submit-submit",
  success: "submit-success",
  backProfile: "submit-back-profile",
  newOne: "submit-new-one",
};

export const PROFILE = {
  page: "profile-page",
  recipesTab: "profile-recipes-tab",
  ordersTab: "profile-orders-tab",
  statusBadge: (slug) => `profile-status-${slug}`,
  editRecipe: (slug) => `profile-edit-${slug}`,
};

export const ADMIN_RECIPES = {
  page: "admin-recipes-page",
  tokenInput: "admin-recipes-token",
  tokenSubmit: "admin-recipes-token-submit",
  card: (id) => `admin-recipe-${id}`,
  approve: (id) => `admin-approve-${id}`,
  reject: (id) => `admin-reject-${id}`,
  rejectReason: (id) => `admin-reject-reason-${id}`,
  rejectConfirm: (id) => `admin-reject-confirm-${id}`,
  switchToLeads: "admin-switch-to-leads",
  empty: "admin-recipes-empty",
};
